import { ScheduleItem } from "@lib/types";

/** Gets temporary ID for schedule item. */
export function getTemporaryScheduleItemId(): ScheduleItem["id"] {
    const timestamp = Date.now();
    const randomNumber = Math.floor(Math.random() * 100);
    return parseInt(`${timestamp}${randomNumber}`, 10);
}
